/**
 * Name of the placeholder route which matches everything until the applet routes are registered.
 * The router performs an initial navigation as soon as it is installed, before the applets have
 * had the chance to add their routes and navigation guards; the placeholder keeps that navigation
 * from complaining about the current URL, and is removed once the real routes are added.
 */
export const InitializingRoute = 'initializing'
